<template>
  <div class="menu-item-attribute" :class="{ 'menu-item-attribute__selected': menuAttribute.selected }">
    <span v-if="index > 0" class="menu-item-attribute__dot"></span>
    {{ getName }}
  </div>
</template>

<script>
import { capFirstLetter } from "@/utils";

export default {
  name: "ItemAttribute",
  props: {
    menuAttribute: Object,
    index: Number
  },
  computed: {
    getName() {
      return capFirstLetter(this.menuAttribute.displayName || this.menuAttribute.name);
    }
  }
};
</script>

<style scoped lang="scss">
.menu-item-attribute {
  display: -webkit-inline-box;
  color: $group-3-color-3;
  font-weight: $font_light;
  font-size: 12px;

  &__selected {
    background-color: $text-color;
    color: white;
    border: solid 1px black;
  }
  &__dot {
    display: list-item;
    margin: 0px -3px 0px 23px;
  }
}
</style>
